import React, { useState } from 'react';
import styles from './StudyManagement.module.css';
import DataCaptureHeader from './Componets/DataCaptureHeader';
import EnrollmentCards from './Componets/Enrollement';
import SubjectsTable from './Componets/SubjectsTable';
import SubjectDrawer from './Componets/SubjectDrawer';
import SubjectLimitModal from './Componets/SubjectModal';
import { useDataCapture } from './hooks';
import LoadingContainer from '../../components/Common/LoadingContainer';

const DataCapture = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [drawerMode, setDrawerMode] = useState('create');
    const [selectedSubject, setSelectedSubject] = useState(null);
    const [enrollmentData, setEnrollmentData] = useState(null);

    const {
        subjects,
        sites,
        loadingSites,
        loadingSubjects,
        canWrite,
        canDataCapture,
        userAssignedSiteId,
        userSite,
        userSubjectsCount,
        studyData,
        userRole,
        showLimitModal,
        setShowLimitModal,
        checkSubjectLimit,
        checkSiteEnrollmentLimit,
        addSubject,
        updateSubject,
        deleteSubject,
        toggleSubjectLock,
        generateSubjectId,
        handleRefreshSubjects,
        fetchEnrollmentData,
        fetchingEnrollmentData
    } = useDataCapture();

    const handleCreateClick = (fetchedEnrollmentData) => {
        if (!checkSubjectLimit()) return;

        setDrawerMode('create');
        setSelectedSubject(null);
        setEnrollmentData(fetchedEnrollmentData);
        setIsDrawerOpen(true);
    };

    const handleViewSubject = (subject) => {
        setDrawerMode('view');
        setSelectedSubject(subject);
        setEnrollmentData(null);
        setIsDrawerOpen(true);
    };

    const handleEditSubject = (subject) => {
        setDrawerMode('edit');
        setSelectedSubject(subject);
        setEnrollmentData(null);
        setIsDrawerOpen(true);
    };

    const handleDrawerSubmit = async (formData) => {
        if (drawerMode === 'create') {
            if (!checkSubjectLimit()) return { success: false, message: 'Subject limit reached' };
            const result = await addSubject(formData);
            if (result && result.success) {
                setIsDrawerOpen(false);
                setEnrollmentData(null);
            }
            return result;
        } else if (drawerMode === 'edit') {
            const result = await updateSubject(formData);
            if (result && result.success) {
                setIsDrawerOpen(false);
            }
            return result;
        }
    };

    const handleCreateAndCapture = async (formData) => {
        if (!checkSubjectLimit()) return { success: false, message: 'Subject limit reached' };
        const result = await addSubject(formData);
        if (result && result.success) {
            setIsDrawerOpen(false);
            setEnrollmentData(null);
        }
        return result;
    };

    const handleDrawerClose = () => {
        setIsDrawerOpen(false);
        setEnrollmentData(null);
    };

    // Show main loading state while initial data is loading
    if (loadingSites && loadingSubjects) {
        return (
            <div className={styles.container}>
                <DataCaptureHeader />
                <LoadingContainer message="Loading data capture..." />
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <DataCaptureHeader />

            <EnrollmentCards
                subjects={subjects}
                studyData={studyData}
                userSite={userSite}
                userRole={userRole}
            />

            <SubjectsTable
                subjects={subjects}
                sites={sites}
                loading={loadingSubjects}
                canWrite={canWrite}
                canDataCapture={canDataCapture}
                onCreateClick={handleCreateClick}
                onViewSubject={handleViewSubject}
                onEditSubject={handleEditSubject}
                onDeleteSubject={deleteSubject}
                onLockSubject={toggleSubjectLock}
                onRefreshSubjects={handleRefreshSubjects}
                fetchEnrollmentData={fetchEnrollmentData}
                fetchingEnrollmentData={fetchingEnrollmentData}
                userAssignedSiteId={userAssignedSiteId}
                userRole={userRole}
            />

            {isDrawerOpen && (
                <SubjectDrawer
                    isOpen={isDrawerOpen}
                    onClose={handleDrawerClose}
                    mode={drawerMode}
                    initialData={drawerMode === 'create' ? enrollmentData : selectedSubject}
                    sites={sites}
                    loadingSites={loadingSites}
                    userAssignedSiteId={userAssignedSiteId}
                    onSubmit={handleDrawerSubmit}
                    onCreateAndCapture={handleCreateAndCapture}
                    generateSubjectId={generateSubjectId}
                    checkSiteLimit={checkSiteEnrollmentLimit}
                />
            )}

            <SubjectLimitModal
                show={showLimitModal}
                onClose={() => setShowLimitModal(false)}
                userSubjectsCount={userSubjectsCount}
            />
        </div>
    );
};

export default DataCapture;